import { get } from "lodash";

import { EditorMode } from "@/Apps/Pages/Editor/types";
import theme from "@/ui/theme";
import { Border } from "@/Apps/Pages/EditorObject/style";
import { parseLiquidObject } from "@/Apps/Pages/Page/LiquidRenderer";

// import { Border } from "@launchos/modules/editor/Builder/EditorObject/style";
// const Border = () => <div></div>

/**
 * Find out if any of the columns in this row currently have a "hover" state
 * @param {*} param0 
 */
const isHoveringOnAnyColumnsInThisRow = ({ pageContent = [], settings: { parent } }) => {
  // get each column
  const getColumns = pageContent.filter((itm) => itm.parent === parent);
  return getColumns.findIndex(({ state }) => state === "hover") > -1;
};

/**
 * Find out if any element in any of the adjacent columns have a "hover" state
 * @param {*} param0 
 */
export default (props) => {
  const { settings, show, borderSize, mode = EditorMode.LIVE, isEmpty = false, EmptyState } = props;
  const style = get(settings, "properties", {});

  const columnStyle: React.CSSProperties = parseLiquidObject({
    ...style,
    ...props.style,
    width: "100%",
    height: "100%",
  });

  return (
    <>
      {(isHoveringOnAnyColumnsInThisRow(props) && mode === EditorMode.EDITOR) && (
        <Border
          borderSize={borderSize}
          show={show}
          settings={settings}
          color={theme.altColors[1]}
          state="hover"
        />
      )}
      <div
        data-testid="WC-COLUMN-LIVE"
        style={columnStyle}
      >
        {(isEmpty && mode === EditorMode.EDITOR) ? <EmptyState {...props} /> : props.children}
      </div>
    </>
  );
};
